module.exports = __webpack_public_path__ + "static/Viso-7261a3bbbf682afe31ddbc03c69cd0f3.png";